import { createStore } 		 from 'vuex';
import landing         		 from './landing';

export default createStore({
	modules:   {
		landing,
	},
});